import React, { useEffect, useState } from "react";
import styles from "./UploadPassportMain.module.css";
import { Link, useHistory, useParams } from "react-router-dom";
import one from "../../../assets/images/one.svg";
import two from "../../../assets/images/two.svg";
import passport from "../../../assets/images/passport1.svg";
import user from "../../../assets/images/user1.svg";

import { useDropzone } from "react-dropzone";
import Dropzone from "react-dropzone";

import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { BsCheckAll } from "react-icons/bs";
import { BiError } from "react-icons/bi";

import camera from "../../../assets/images/camera.svg";

import { connect } from "react-redux";
import changePassportDetails from "../../../store/Actions/PassportDetailsAction";
import changeDetails from "../../../store/Actions/DetailsAction"

import { uploadApplicationDocumentsApi } from "../../../config/uploadApplicationDocumentsApi";

import { ocrApi } from "../../../config/OcrApi";

function UploadPassportMain(props) {
  useEffect(() => {
    if (props.passportDetails.application !== true) {
      history.push("/dashboard/my-applications");
    } else {
      setId(props.passportDetails.id);

      function getWithExpiry(key) {
        const itemStr = localStorage.getItem(key);
        if (!itemStr) {
          return null;
        }
        const item = JSON.parse(itemStr);
        setToken(item.value.token);
      }
      getWithExpiry("userData");
    }
  }, []);
  console.log(props.details)

  // let { id } = useParams();
  const [id, setId] = useState("");
  const [token, setToken] = useState("");
  const history = useHistory();
  const [loading, setLoading] = useState(false);

  const [image1, setImage1] = useState([]);
  const [image2, setImage2] = useState([]);
  const [fileName1, setFileName1] = useState("");
  const [fileName2, setFileName2] = useState("");
  const [fileType1, setFileType1] = useState("");
  const [fileType2, setFileType2] = useState("");

  const [upload1, setUpload1] = useState("");
  const [upload2, setUpload2] = useState("");

  const accept1 = ["png", "jpg", "jpeg", "gif", "docx", "pdf"];
  const accept2 = ["png", "jpg", "jpeg", "gif"];

  const handleDrop1 = (acceptedFiles) => {
    const name = acceptedFiles[0].name;
    const lastDot = name.lastIndexOf(".");
    const fileName = name.substring(0, lastDot);
    const ext = name.substring(lastDot + 1);

    if (accept1.includes(ext.toLowerCase())) {
      setImage1(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
      setFileName1(acceptedFiles[0].name);
      setFileType1(ext);
      setUpload1(acceptedFiles[0]);
    } else {
      setImage1([]);
      setFileName1("");
      setFileType1("");
      setUpload1("");
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          {`${name} not acccepted as passport file`}
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    }
  };

  const handleDrop2 = (acceptedFiles) => {
    const name = acceptedFiles[0].name;
    const lastDot = name.lastIndexOf(".");
    const fileName = name.substring(0, lastDot);
    const ext = name.substring(lastDot + 1);

    if (accept2.includes(ext.toLowerCase())) {
      setImage2(
        acceptedFiles.map((file) =>
          Object.assign(file, {
            preview: URL.createObjectURL(file),
          })
        )
      );
      setFileName2(acceptedFiles[0].name);
      setFileType2(ext);
      setUpload2(acceptedFiles[0]);
    } else {
      setImage2([]);
      setFileName2("");
      setFileType2("");
      setUpload2("");

      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          {`${name} not acccepted as passport photograph`}
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    }
  };

  const thumb1 = (
    <div>
      <div>
        {accept2.includes(fileType1.toLowerCase()) ? (
          <img
            style={{ width: "200px", height: "150px" }}
            src={image1[0].preview}
          />
        ) : (
          <h1 className={styles.headhead}>{fileName1}</h1>
        )}
      </div>
    </div>
  );

  const thumb2 = (
    <div>
      <div>
        {accept2.includes(fileType2.toLowerCase()) ? (
          <img
            style={{ width: "200px", height: "150px" }}
            src={image2[0].preview}
          />
        ) : (
          <h1 className={styles.headhead}>{fileName2}</h1>
        )}
      </div>
    </div>
  );

  const continueData = () => {
    if (image1.length !== 0 && image2.length !== 0) {
      setLoading(true);

      const upload = async () => {
        const uploadImage1 = await uploadApplicationDocumentsApi(
          id,
          token,
          upload1,
          "Passport File",
          ""
        );
        if (uploadImage1.error) {
          setLoading(false);
          toast.error(
            <span style={{ display: "flex", alignItems: "center" }}>
              <BiError size="30" style={{ marginRight: "10px" }} />
              {uploadImage1.error.message}
            </span>,
            {
              position: "bottom-left",
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: true,
              progress: undefined,
            }
          );
        } else if (uploadImage1.data) {
          console.log(uploadImage1.data)
          console.log(uploadImage1.data.document_id)
          const ocr = await ocrApi(uploadImage1.data.links[0].url);

          if(ocr.error){
            console.log(ocr.error)
          }

          else if(ocr.data){
            if(ocr.data.data !== undefined){
                const data = {
              ...props.details,
              formId: uploadImage1.data.document_id,
              givenName: ((ocr.data.data.fields.firstName !== null)?(ocr.data.data.fields.firstName): ""),
              surName: ((ocr.data.data.fields.lastName !== null)?(ocr.data.data.fields.lastName): ""),
              passportType: ((ocr.data.data.fields.documentCode !== null)?(ocr.data.data.fields.documentCode): ""),
              passportNumber: ((ocr.data.data.fields.documentNumber !== null)?(ocr.data.data.fields.documentNumber): ""),
              sex: ((ocr.data.data.fields.sex !== null)?(ocr.data.data.fields.sex): ""),
              nationality: ((ocr.data.data.fields.nationality !== null)?(ocr.data.data.fields.nationality): ""),
              dateOfBirthDate:  ((ocr.data.data.fields.birthDate !== null)?(ocr.data.data.fields.birthDate.split("")[4] + ocr.data.data.fields.birthDate.split("")[5]):""),
              dateOfBirthMonth: ((ocr.data.data.fields.birthDate !== null)?(ocr.data.data.fields.birthDate.split("")[2] + ocr.data.data.fields.birthDate.split("")[3]):""),
              dateOfBirthYear:  ((ocr.data.data.fields.birthDate !== null)?(ocr.data.data.fields.birthDate.split("")[0] + ocr.data.data.fields.birthDate.split("")[1]):""),
              passportExpiryDate   : ((ocr.data.data.fields.expirationDate !== null)?(ocr.data.data.fields.expirationDate.split("")[4] + ocr.data.data.fields.expirationDate.split("")[5]):""),
              passportExpiryMonth : ((ocr.data.data.fields.expirationDate !== null)?(ocr.data.data.fields.expirationDate.split("")[2] + ocr.data.data.fields.expirationDate.split("")[3]):""),
              passportExpiryYear   : ((ocr.data.data.fields.expirationDate !== null)?(20+ocr.data.data.fields.expirationDate.split("")[0] + ocr.data.data.fields.expirationDate.split("")[1]):""),
            }
            props.ChangeDetails(data)
            console.log(ocr.data.data.fields)
            }
           
            console.log(ocr.data)
          }

          const uploadImage2 = await uploadApplicationDocumentsApi(
            id,
            token,
            upload2,
            "Passport Photograph",
            uploadImage1.data.document_id
          );

          if (uploadImage2.error) {
            setLoading(false);
            toast.error(
              <span style={{ display: "flex", alignItems: "center" }}>
                <BiError size="30" style={{ marginRight: "10px" }} />
                {uploadImage2.error.message}
              </span>,
              {
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
              }
            );
          } else if (uploadImage2.data) {
          console.log(uploadImage2)
            history.push(`/dashboard/my-applications/${id}/passport-info`)
          }
        }
      };
      upload();
    } else {
      toast.error(
        <span style={{ display: "flex", alignItems: "center" }}>
          <BiError size="30" style={{ marginRight: "10px" }} />
          Both Files Are Required!
        </span>,
        {
          position: "bottom-left",
          autoClose: 5000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: true,
          progress: undefined,
        }
      );
    }
  };
  return (
    <div>
      <h2 className={styles.head}>Passport upload</h2>
      <h2 className={styles.head2}>
        Upload your passport data page and your photograph
      </h2>
      <div className={styles.boxx}>
        <div className={styles.box}>
          <div className={styles.boxFirst}>
            <div>
              <img src={one} alt="One" className={styles.one} />
            </div>
            <div className={styles.boxFirstIn}>
              <h1 className={styles.boxFirstHead}>
                Upload your passport data page
              </h1>
              <p className={styles.boxFirstDes}>
                Upload only the scanned copy of your passport data page here.
              </p>
            </div>
          </div>
          <>
            {image1.length === 0 ? (
              <Dropzone onDrop={handleDrop1} className={styles.boxSecond}>
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps({ className: styles.boxSecond })}>
                    <input
                      {...getInputProps()}
                      accept=".png,.jpg,.gif,.pdf,.docx"
                    />
                    <img
                      src={passport}
                      alt="User"
                      className={styles.passportImage}
                    />
                    <h2 className={styles.boxSecondHead}>
                      Drag and drop your passport file here or click to select
                    </h2>
                    <h2 className={styles.boxSecondHeadMobile}>Choose file</h2>
                    <img
                      className={styles.cameraMobile}
                      src={camera}
                      alt="camera"
                    />
                  </div>
                )}
              </Dropzone>
            ) : (
              <Dropzone
                onDrop={handleDrop1}
                className={`${styles.boxSecond} ${styles.boxSecond1}`}
              >
                {({ getRootProps, getInputProps }) => (
                  <div
                    {...getRootProps({
                      className: `${styles.boxSecond} ${styles.boxSecond1}`,
                    })}
                  >
                    <input
                      {...getInputProps()}
                      accept=".png,.jpg,.gif,.pdf,.docx"
                    />
                    {thumb1}
                  </div>
                )}
              </Dropzone>
            )}
          </>
        </div>
        <hr className={styles.line} />
        <div className={styles.box}>
          <div className={styles.boxFirst}>
            <div>
              <img src={two} alt="Two" className={styles.one} />
            </div>
            <div className={styles.boxFirstIn}>
              <h1 className={styles.boxFirstHead}>
                Upload your passport photograph
              </h1>
              <p className={styles.boxFirstDes}>
                Upload your passport photograph here.
              </p>
            </div>
          </div>
          <>
            {image2.length === 0 ? (
              <Dropzone onDrop={handleDrop2} className={styles.boxSecond}>
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps({ className: styles.boxSecond })}>
                    <input {...getInputProps()} accept=".png,.jpg,.gif" />
                    <img src={user} alt="User" className={styles.userImage} />
                    <h2 className={styles.boxSecondHead}>
                      Drag and drop your photograph here or click to select
                    </h2>
                    <h2 className={styles.boxSecondHeadMobile}>Choose file</h2>
                    <img
                      className={styles.cameraMobile}
                      src={camera}
                      alt="camera"
                    />
                  </div>
                )}
              </Dropzone>
            ) : (
              <Dropzone
                onDrop={handleDrop2}
                className={`${styles.boxSecond} ${styles.boxSecond1}`}
              >
                {({ getRootProps, getInputProps }) => (
                  <div
                    {...getRootProps({
                      className: `${styles.boxSecond} ${styles.boxSecond1}`,
                    })}
                  >
                    <input {...getInputProps()} accept=".png,.jpg,.gif" />
                    {thumb2}
                  </div>
                )}
              </Dropzone>
            )}
          </>
        </div>
        <div className={styles.btnCont}>
          <button className={styles.continueBtn} onClick={() => continueData()}>
            {loading ? (
              <div class="spinner-border" role="status"></div>
            ) : (
              "Continue"
            )}
          </button>
        </div>
      </div>
      <ToastContainer
        transition={Slide}
        position="bottom-left"
        autoClose={5000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover={false}
        className={styles.toasst}
      />
    </div>
  );
}

const mapStateToProps = (state) => ({
  passportDetails: state.PassportDetails.passportDetails,
  details: state.Details.details,
});

const mapDispatchToProp = (dispatch) => ({
  ChangePassportDetails: (passportDetails) =>
    dispatch(changePassportDetails(passportDetails)),
  ChangeDetails: (details) =>
    dispatch(changeDetails(details)),
});

export default connect(mapStateToProps, mapDispatchToProp)(UploadPassportMain);
